import http from "./http";
import notificationsMock from "./mocks/notificationsMock";

const USE_MOCK = process.env.REACT_APP_NOTIF_MOCK === "true";

class NotificationsService {
    index(page, token){
        if (USE_MOCK) return notificationsMock.index(page);
        return http.get(`/api/v01/web/notifications/index?page=${page}`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    unreadCount(token){
        if (USE_MOCK) return notificationsMock.unreadCount();
        return http.get("/api/v01/web/notifications/unread-count",{ headers: { 'Authorization': 'Bearer '+token } })
    }

    markAsRead(id, token){
        if (USE_MOCK) return notificationsMock.markAsRead(id);
        return http.patch(`/api/v01/web/notifications/${id}/read`, {}, { headers: { 'Authorization': 'Bearer '+token } })
    }

    markAllAsRead(token){
        if (USE_MOCK) return notificationsMock.markAllAsRead();
        return http.post("/api/v01/web/notifications/read-all", {}, { headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new NotificationsService()